import {
    getObjects,
    createObjects,
    updateObjects,
    deleteObjects,
    getCognitoUser,
} from './../api/webApplicationApi';
import { User } from './user';

const objectType = 'identity';

export class Identity {
    private _saveMethod = createObjects;
    private _object: omIdentity;
    private _cognitoUser: any;
    private _lastError: Error;

    public constructor(identityID: string) {
        this._object = {
            identityID: identityID,
            email: undefined,
            firstLogin: undefined,
            lastLogin: undefined,
            users: [],
        };
    }

    public static createFromObject(identity: omIdentity): Identity {
        const obj = new Identity(identity.identityID);
        obj._object = identity;
        obj._saveMethod = updateObjects;
        return obj;
    }

    public async load(): Promise<boolean> {
        const getObject: GetRequest = {
            objectType: objectType,
            keys: [this._object.identityID],
        };
        this._lastError = undefined;
        try {
            const response = await getObjects([getObject]);
            if (
                response &&
                response.length > 0 &&
                response[0].objects &&
                response[0].objects.length == 1
            ) {
                this._saveMethod = updateObjects;
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('identity not found');
                return false;
            }
        } catch (error: unknown) {
            this._lastError = error as Error;
            return false;
        }
    }

    public async save(): Promise<boolean> {
        const saveObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;

        if (this._object.email == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([saveObject]);
            if (response) {
                this._saveMethod = updateObjects;
            } else {
                this._lastError = new Error('unknow server error');
            }
            return response;
        } catch (error: unknown) {
            this._lastError = error as Error;
            return false;
        }
    }

    public async delete(): Promise<boolean> {
        const deleteObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;
        try {
            const response = await deleteObjects([deleteObject]);
            return response;
        } catch (error: unknown) {
            this._lastError = error as Error;
            return false;
        }
    }

    public async loadCognitoUser(): Promise<boolean> {
        if (!this._cognitoUser) {
            const getCognitoUserRequest: GetCognitoUserRequest = {
                email: this._object.email,
            };
            this._cognitoUser = await getCognitoUser(getCognitoUserRequest);
        }

        return true;
    }

    public get cognitoUser(): any {
        return this._cognitoUser;
    }

    public get lastError(): Error {
        return this._lastError;
    }

    public get identityID(): string {
        return this._object.identityID;
    }

    public get email(): string {
        return this._object.email;
    }

    public set email(email: string) {
        this._object.email = email;
    }

    public get firstLogin(): Date {
        if (this._object.firstLogin) return new Date(this._object.firstLogin);

        return undefined;
    }

    public get lastLogin(): Date {
        if (this._object.lastLogin) return new Date(this._object.lastLogin);

        return undefined;
    }

    public get users(): string[] {
        return this._object.users;
    }

    public addUser(user: User): void {
        if (this._object.users.includes(user.userID)) return;
        this._object.users.push(user.userID);
    }

    public deleteUser(user: User): void {
        const index = this._object.users.indexOf(user.userID);
        if (index > -1) {
            this._object.users.splice(index, 1);
        }
    }
}
